import {
  Col,
  ErrorText,
  Hint,
  Row,
  SectionTitle,
  SwitchButtons
} from '@elotech/components';
import classnames from 'classnames';
import { TipoAplicacaoAliquotaDiferenciadaItbi } from 'itbi-common/utils';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';

import AliquotaIntevaloValorTable from './AliquotaIntevaloValorTable';

const Label = styled.label`
  font-size: 12px;
`;

const ValoresTransferenciaSection = ({
  tipoItbi,
  valoresItbi,
  valoresFinanciamento,
  valorCalculado = 0,
  onChangeValoresItbi,
  onChangePercentualIsencaoItbi,
  onChangeObservacao,
  observacaoIsencao,
  errors,
  errorMessages,
  onShowAvaliacoes,
  hasRole,
  isServidor,
  retificadora,
  utilizaFluxoAutonomiaCidadao,
  valorRecursoProprio
}) => {
  const isCidadaoFluxoAutonomiaCidadao =
    !isServidor && utilizaFluxoAutonomiaCidadao;

  const normalizedOnChange = ({ floatValue }, { target: { name } }) => {
    onChangeValoresItbi({
      target: {
        name,
        value: floatValue
      }
    });
  };

  const onChangeTipoFiltro = () => {
    if (valorIsencao === 'VALOR') {
      setValorIsencao('PERCENTUAL');
    } else {
      setValorIsencao('VALOR');
    }
  };

  const tipoFiltroOptions = [
    {
      key: 'PERCENTUAL',
      value: 'PERCENTUAL',
      label: 'Percentual'
    },
    {
      key: 'VALOR',
      value: 'VALOR',
      label: 'Valor'
    }
  ];

  const normalizedOnChangePercentualIsencao = (
    { floatValue },
    { target: { name } }
  ) => {
    onChangePercentualIsencaoItbi({
      target: {
        name,
        value: floatValue
      }
    });
  };

  const [valorIsencao, setValorIsencao] = useState('VALOR');

  const {
    utilizaAliquotaDiferenciadaTipoNormal,
    utilizaAliquotaDiferenciadaTipoFinanciadoAVista,
    utilizaAliquotaDiferenciadaTipoFinanciado,
    tipoAliquotaDiferenciadaNormal,
    tipoAliquotaDiferenciadaFinanciadoAVista,
    tipoAliquotaDiferenciadaFinanciado
  } = tipoItbi.parametroItbi;

  const utilizaAliquotasDiferenciada =
    ((tipoItbi.normal || tipoItbi.isencao) &&
      utilizaAliquotaDiferenciadaTipoNormal) ||
    (tipoItbi.financiado &&
      (utilizaAliquotaDiferenciadaTipoFinanciado ||
        utilizaAliquotaDiferenciadaTipoFinanciadoAVista));

  const renderAliquotaDiferenciada = () => {
    return !utilizaAliquotasDiferenciada ? (
      undefined
    ) : (
      <>
        {utilizaAliquotaDiferenciadaTipoNormal &&
          (tipoItbi.normal || tipoItbi.isencao) && (
            <AliquotaIntevaloValorTable
              tipoItbi="Normal - Avaliação"
              valorReferencia={valoresItbi.valorTransacaoAvaliacao}
              tipoAplicacao={tipoAliquotaDiferenciadaNormal}
              aliquotas={tipoItbi.parametroItbi.aliquotasNormal}
            />
          )}
        {utilizaAliquotaDiferenciadaTipoFinanciadoAVista &&
          tipoItbi.financiado && (
            <AliquotaIntevaloValorTable
              tipoItbi="Financiado - Avaliação"
              valorReferencia={valoresItbi.valorTransacaoAvaliacao}
              tipoAplicacao={tipoAliquotaDiferenciadaFinanciadoAVista}
              aliquotas={tipoItbi.parametroItbi.aliquotasFinanciadoAVista}
            />
          )}
        {utilizaAliquotaDiferenciadaTipoFinanciado &&
          tipoItbi.financiado &&
          !aplicaAliquotaGeralFinanciado() && (
            <AliquotaIntevaloValorTable
              tipoItbi="Financiado - Avaliação Financiado"
              valorReferencia={valoresFinanciamento.valorFinanciadoAvaliacao}
              tipoAplicacao={tipoAliquotaDiferenciadaFinanciado}
              aliquotas={tipoItbi.parametroItbi.aliquotasFinanciado}
            />
          )}
      </>
    );
  };

  const usaAliquotaGeralFinanciado = () =>
    tipoItbi.parametroItbi.usaAliquotaGeralFinanciado;

  const getValorAvaliadoTotal = () =>
    valoresItbi.valorTransacaoAvaliacao +
    valoresFinanciamento.valorFinanciadoAvaliacao;

  const getAliquotaGeralValorFinanciado = () =>
    tipoItbi.parametroItbi.aliquotaGeralValorFinanciado;

  const aplicaAliquotaGeralFinanciado = () => {
    return (
      usaAliquotaGeralFinanciado() &&
      getValorAvaliadoTotal() >= getAliquotaGeralValorFinanciado()
    );
  };

  const getLabelValorTransacaoAvaliacao = () => {
    if (valorRecursoProprio && tipoItbi.financiado) {
      return 'Valor Recurso Próprio';
    }

    return isServidor ? 'Valor Avaliação' : 'Valor do Imóvel';
  };

  return (
    <div>
      <SectionTitle>Valores da Transferência</SectionTitle>
      <Row>
        {isServidor && (
          <Col md={2} className="form-group">
            <Label htmlFor="valorTransacaoInput">
              {valorRecursoProprio && tipoItbi.financiado
                ? 'Valor Recurso Próprio'
                : 'Valor Transação'}
            </Label>
            <NumberFormat
              prefix="R$ "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              value={valoresItbi.valorTransacao}
              name="valorTransacao"
              disabled
            />
          </Col>
        )}
        {isServidor && (
          <Col md={2} className="form-group">
            <Label htmlFor="valorTransacaoAvaliacaoInput">
              Valor Calculado
            </Label>
            <NumberFormat
              prefix="R$ "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              value={valorCalculado}
              name="valorAvaliadoTotal"
              id="valorTransacaoAvaliacaoInput"
              disabled
            />
          </Col>
        )}
        <Col md={2} className="form-group">
          <Label htmlFor="valorTransacaoAvaliacaoInput">
            {getLabelValorTransacaoAvaliacao()}
            {!isServidor && (
              <Hint classes="inline clean module-color fa-exclamation-circle mobile sm">
                O valor da transação declarado pelo contribuinte goza da
                presunção de que é condizente com o valor de mercado que somente
                pode ser afastado pelo fisco mediante a regular instauração de
                processo administrativo próprio (artigo 148 do CNT)
              </Hint>
            )}
          </Label>
          <NumberFormat
            prefix="R$ "
            decimalSeparator=","
            thousandSeparator="."
            decimalScale={2}
            allowNegative={false}
            fixedDecimalScale
            value={valoresItbi.valorTransacaoAvaliacao}
            name="valorTransacaoAvaliacao"
            id="valorTransacaoAvaliacaoInput"
            onValueChange={normalizedOnChange}
            className={classnames({
              error: errors?.valorTransacaoAvaliacao,
              right: true
            })}
          />
          {errors?.valorTransacaoAvaliacao && (
            <ErrorText>{errorMessages?.valorTransacaoAvaliacao}</ErrorText>
          )}
        </Col>
        <Col md={2} className="form-group">
          {(((tipoItbi.normal &&
            utilizaAliquotaDiferenciadaTipoNormal &&
            tipoAliquotaDiferenciadaNormal ===
              TipoAplicacaoAliquotaDiferenciadaItbi.INTERVALO) ||
            (tipoItbi.financiado &&
              utilizaAliquotaDiferenciadaTipoFinanciadoAVista &&
              tipoAliquotaDiferenciadaFinanciadoAVista ===
                TipoAplicacaoAliquotaDiferenciadaItbi.INTERVALO)) && (
            <>
              <Label className="label"></Label>
              <Label>
                Aliquota diferenciada:{' '}
                {(tipoItbi.normal && tipoAliquotaDiferenciadaNormal) ||
                  (tipoItbi.financiado &&
                    tipoAliquotaDiferenciadaFinanciadoAVista)}
              </Label>
            </>
          )) || (
            <>
              <Label htmlFor="aliquotaTransacao">Alíquota Padrão</Label>
              <NumberFormat
                suffix=" %"
                decimalSeparator=","
                thousandSeparator="."
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                value={valoresItbi.aliquotaTransacao}
                name="aliquotaTransacao"
                disabled
              />
            </>
          )}
        </Col>
        <Col md={2} className="form-group">
          <Label htmlFor="valorTransacaoItbi">Valor ITBI</Label>
          <NumberFormat
            prefix="R$ "
            decimalSeparator=","
            thousandSeparator="."
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            value={valoresItbi.valorTransacaoItbi}
            name="valorTransacaoItbi"
            disabled
          />
        </Col>
        {isServidor && hasRole && hasRole('itbi_consultar_ultimas_avaliacoes') && (
          <Col md={2} className="form-group">
            <Label className="label" />
            <button className="btn module-color" onClick={onShowAvaliacoes}>
              Últimas avaliações
            </button>
          </Col>
        )}
      </Row>
      {tipoItbi.financiado || tipoItbi.anuencia ? (
        <Row>
          {isServidor && (
            <Col md={2} className="form-group">
              <Label htmlFor="valorFinanciadoInput">
                {tipoItbi.financiado ? 'Valor Financiado' : 'Valor Anuência'}
              </Label>
              <NumberFormat
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                value={valoresFinanciamento.valorFinanciado}
                name="valorFinanciadoInput"
                disabled
              />
            </Col>
          )}
          <Col
            md={2}
            mdOffset={isCidadaoFluxoAutonomiaCidadao ? 0 : 2}
            className="form-group"
          >
            <Label htmlFor="valorFinanciadoAvaliacaoInput">
              {tipoItbi.financiado
                ? 'Valor Financiado Avaliação'
                : 'Valor Anuência Avaliação'}
            </Label>
            <NumberFormat
              prefix="R$ "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              value={valoresFinanciamento.valorFinanciadoAvaliacao}
              name="valorFinanciadoAvaliacao"
              id="valorFinanciadoAvaliacaoInput"
              onValueChange={normalizedOnChange}
              className={classnames({
                error: errors.valorFinanciadoAvaliacao,
                right: true
              })}
            />
            {errors.valorFinanciadoAvaliacao && (
              <ErrorText>{errorMessages.valorFinanciadoAvaliacao}</ErrorText>
            )}
          </Col>
          <Col md={2} className="form-group">
            {(tipoItbi.financiado &&
              utilizaAliquotaDiferenciadaTipoFinanciado &&
              tipoAliquotaDiferenciadaFinanciado ===
                TipoAplicacaoAliquotaDiferenciadaItbi.INTERVALO &&
              !aplicaAliquotaGeralFinanciado() && (
                <>
                  <Label className="label"></Label>
                  <Label>
                    Aliquota diferenciada:{' '}
                    {tipoItbi.financiado &&
                      tipoAliquotaDiferenciadaFinanciado &&
                      tipoAliquotaDiferenciadaFinanciado.toLocaleUpperCase()}
                  </Label>
                </>
              )) || (
              <>
                <Label htmlFor="aliquotaFinanciado">Alíquota Padrão</Label>
                <NumberFormat
                  suffix=" %"
                  decimalSeparator=","
                  thousandSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                  allowNegative={false}
                  value={valoresFinanciamento.aliquotaFinanciado}
                  name="aliquotaFinanciado"
                  disabled
                />
              </>
            )}
          </Col>
          <Col md={2} className="form-group">
            <Label htmlFor="valorFinanciadoItbi">Valor ITBI</Label>
            <NumberFormat
              prefix="R$ "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              value={valoresFinanciamento.valorFinanciadoItbi}
              name="valorFinanciadoItbi"
              disabled
            />
          </Col>
        </Row>
      ) : null}
      <Row>
        <Col md={2} mdOffset={isServidor ? 4 : 0} className="form-group">
          <Label htmlFor="totalAvaliado">Valor Total Avaliação</Label>
          <NumberFormat
            prefix="R$ "
            decimalSeparator=","
            thousandSeparator="."
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            value={
              valoresItbi.valorTransacaoAvaliacao +
              valoresFinanciamento.valorFinanciadoAvaliacao
            }
            name="totalAvaliado"
            disabled
          />
        </Col>
        {retificadora && (
          <Col md={2} mdOffset={2} className="form-group">
            <Label htmlFor="totalOriginal">
              Valor ITBI da Declaração Original
            </Label>
            <NumberFormat
              prefix="R$ "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              value={valoresItbi.valorOriginal}
              name="totalOriginalITBI"
              disabled
            />
          </Col>
        )}
        <Col md={2} mdOffset={retificadora ? 0 : 2} className="form-group">
          <Label htmlFor="totalITBI">Valor Total ITBI</Label>
          <NumberFormat
            prefix="R$ "
            decimalSeparator=","
            thousandSeparator="."
            decimalScale={2}
            fixedDecimalScale
            allowNegative={false}
            value={
              valoresItbi.valorTransacaoItbi +
              valoresFinanciamento.valorFinanciadoItbi
            }
            name="totalITBI"
            disabled
          />
        </Col>
        {retificadora && (
          <Col md={2} className="form-group">
            <Label htmlFor="valorItbiRetificado">Valor ITBI Retificado</Label>
            <NumberFormat
              prefix="R$ "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              value={Math.max(
                0,
                valoresItbi.valorTransacaoItbi +
                  valoresFinanciamento.valorFinanciadoItbi -
                  (valoresItbi.valorOriginal || 0)
              )}
              name="valorItbiRetificado"
              disabled
            />
          </Col>
        )}
      </Row>
      {tipoItbi.isencao && (
        <Row>
          <Col md={2}>
            <label className="label">Tipo de Isenção</label>
            <SwitchButtons
              value={valorIsencao}
              onChange={onChangeTipoFiltro}
              name="tipoIsencao"
              options={tipoFiltroOptions}
            />
          </Col>
        </Row>
      )}
      <Row>
        {tipoItbi.isencao && valorIsencao === 'VALOR' && (
          <Col md={2} className="form-group">
            <Label htmlFor="valorIsencaoInput">Valor Total Isenção</Label>
            <NumberFormat
              prefix="R$ "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              allowNegative={false}
              fixedDecimalScale
              name="valorIsencao"
              id="valorIsencaoInput"
              value={valoresItbi.valorIsencao}
              onValueChange={normalizedOnChange}
              className={classnames({
                error:
                  errors.valorIsencaoMenorIgualZero ||
                  errors.valorIsencaoMaiorAvaliacao,
                right: true
              })}
            />
            {errors.valorIsencao && (
              <ErrorText>{errorMessages.valorIsencaoMenorIgualZero}</ErrorText>
            )}
            {errors.valorIsencaoMaiorAvaliacao && (
              <ErrorText>{errorMessages.valorIsencaoMaiorAvaliacao}</ErrorText>
            )}
          </Col>
        )}
        {tipoItbi.isencao && valorIsencao === 'PERCENTUAL' && (
          <Col md={2} className="form-group">
            <Label htmlFor="PercentualIsencaoInput">
              Percentual Total Isenção
            </Label>
            <NumberFormat
              prefix="% "
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={0}
              allowNegative={false}
              fixedDecimalScale
              name="percentualIsencao"
              id="PercentualIsencaoInput"
              onValueChange={normalizedOnChangePercentualIsencao}
              className={classnames({
                error:
                  errors.percentualIsencaoMenorIgualZero ||
                  errors.percentualIsencaoMaiorCem,
                right: true
              })}
            />
            {errors.percentualIsencaoMenorIgualZero && (
              <ErrorText>
                {errorMessages.percentualIsencaoMenorIgualZero}
              </ErrorText>
            )}
            {errors.percentualIsencaoMaiorCem && (
              <ErrorText>{errorMessages.percentualIsencaoMaiorCem}</ErrorText>
            )}
          </Col>
        )}
        {tipoItbi.isencao && (
          <Col md={12}>
            <div className="form-group">
              <label htmlFor="observacaoIsencaoInput">Motivo Isenção</label>
              <textarea
                id="observacaoIsencaoInput"
                name="observacaoIsencao"
                maxLength={200}
                value={observacaoIsencao || ''}
                onChange={onChangeObservacao}
              />
              <div
                className="help-message gray-60 right col-md-12"
                data-testid="contador-textarea"
              >
                {`${(observacaoIsencao || '').length}/200`}
              </div>
            </div>
          </Col>
        )}
      </Row>
      {renderAliquotaDiferenciada()}
    </div>
  );
};

ValoresTransferenciaSection.propTypes = {
  tipoItbi: PropTypes.object.isRequired,
  valorCalculado: PropTypes.number,
  observacaoIsencao: PropTypes.string,
  valoresItbi: PropTypes.shape({
    valorTransacao: PropTypes.number,
    valorTransacaoAvaliacao: PropTypes.number,
    aliquotaTransacao: PropTypes.number,
    valorTransacaoItbi: PropTypes.number,
    valorIsencao: PropTypes.number,
    valorOriginal: PropTypes.number
  }),
  valoresFinanciamento: PropTypes.shape({
    valorFinanciado: PropTypes.number,
    valorFinanciadoAvaliacao: PropTypes.number,
    aliquotaFinanciado: PropTypes.number,
    valorFinanciadoItbi: PropTypes.number
  }),
  errors: PropTypes.object,
  errorMessages: PropTypes.object,
  onChangeValoresItbi: PropTypes.func.isRequired,
  onChangePercentualIsencaoItbi: PropTypes.func.isRequired,
  onChangeObservacao: PropTypes.func.isRequired,
  hasRole: PropTypes.func,
  isServidor: PropTypes.bool,
  retificadora: PropTypes.bool,
  utilizaFluxoAutonomiaCidadao: PropTypes.bool
};

export default ValoresTransferenciaSection;
